export default __webpack_public_path__ + "static/Category4-8b1d9103e70f7f156813f8a6a032f22e.jpg";